module.exports = __webpack_public_path__ + "static/media/header-background.d5b4548e.png";